import React from 'react';
import '../ContactUs/ContactUs.css';
import Header from '../Header/header';
import Footer from '../Footer/footer';
import FormfacadeEmbed from "@formfacade/embed-react";

const ContactUs = () => {
    
    return (

        <>

        <Header/>
        
        <div className="contact-us-page">

             {/* Company Google Form Section */}
             <h1>For Employers</h1>
                 <h2>Are you looking for Candidates?</h2>
            <h3>Fill up this form and we'll get back to you!</h3>
            <div className="google-form-container">
                <iframe
                    title="new-google-form"
                    src="https://forms.gle/q3ThVccK3qYLiFo27"
                    width="100%"
                    height="800"
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    style={{ border: 'none' }}
                >
                    Loading…
                </iframe>
            </div>



            {/* Candidate Google Form Section */}
           <h1>For Candidates</h1> 
            <h2>Are you looking for a job opportunity?</h2>
            <h3>Fill up this form and we'll get back to you!</h3>
            <div id="candidate-form" className="google-form-container">
                   
             

             {/*  <iframe
                        title="google-form"
                        src="https://forms.gle/k5U2AAsmAP2yYgRZA"
                        width="100%"
                        height="800"
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                        style={{ border: 'none' }}
                    >
                        Loading…
                    </iframe> */}


<FormfacadeEmbed

formFacadeURL="https://formfacade.com/include/100390545416593210171/form/1FAIpQLSeEwpxMLIwLLG1N1cMsxTkX4zLAFEQhoBZx-77BCOevj9GxJw/classic.js/?div=ff-compose"

onSubmitForm={() => console.log('Form submitted')}

/>


                </div>

                
        {/* Contact Details Section */}
            
            <div id='contact-details-section' className="contact-details">
    <div className="contact-info">
        <h2><strong>Our Office🏢</strong></h2>
        <p><strong>Address: </strong>Hadapsar, Phursungi, Maharashtra,Pincode : 412308 </p>
        <p><strong>Phone:</strong> +91 9404250794 </p>
        <p><strong>Mail : </strong>hr@shritech.in </p>
       
    </div>
    <div className="map-container">
        <iframe
            title="office-map"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.7021365391014!2d73.9451127!3d18.4812115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e9456e9c1abf%3A0x60b3f1842ccac7b4!2sSurvey%20No.%20201%2F202%2FA%2F3%2FPLOT%20B%20%26%20Survey%20No.%20201%2F202%2C%20A%2F4%2C%20Kale%20Padal%20Bypass%20Rd%2C%20Hadapsar%2C%20Phursungi%2C%20Maharashtra%20412308!5e0!3m2!1sen!2sin!4v1612567371441!5m2!1sen!2sin"
            width="600"
            height="450"
            allowFullScreen=""
            loading="lazy"
        ></iframe>
    </div>
</div>

        </div>

        {/* Footer Section */}
        <Footer/>

        </>

        
    );
};

export default ContactUs;
